import { AccountNotification } from "./accountNotification";

export class DynamicTabModel {
    title: string;
    disabled: boolean;
    removable: boolean;
    active: boolean;
    componentName: any;
    id: any;
    orderNumber?: string;
    webOrderNumber?: string;
    country?: string;
    isNewOrder:number;
    memberType?: string;
    orderType? :string;
    notification?: AccountNotification;
    activeTab?: number;
}


// WEBPACK FOOTER //
// ./src/app/customerservice/interface/dynamic-tab-model.ts